import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  ModalAction,
  ModalBody,
  ModalButton,
} from '../../../../../../components/Modal/Modal';
import { trans } from '../../../../../../localization';
import { startTransferringOrder, stopTransferringOrder } from '../actions';
import ErrorIcon from '../../../../../../assets/common/images/icon/error.png';

class TransferOrderError extends Component {
  render() {
    const {
      transferredOrder,
      startTransferringOrderConnect,
      stopTransferringOrderConnect,
    } = this.props;

    return (
      <Fragment>
        <ModalBody>
          <div className="signal-verify-container">
            <img src={ErrorIcon} className="signal-verify" alt="icon" />
          </div>

          <p className="verifying-text">{trans('error_transfer_order')}</p>

          <p className="verifying-subtext">{trans('please_try_again')}</p>
        </ModalBody>

        <ModalAction>
          <ModalButton
            className="text-blue button-cancel"
            onClick={stopTransferringOrderConnect}
          >
            {trans('common_cancel')}
          </ModalButton>
          <ModalButton
            className="btn-blue button-confirm"
            onClick={() => startTransferringOrderConnect(transferredOrder)}
          >
            {trans('choose_another_branch')}
          </ModalButton>
        </ModalAction>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  transferredOrder: state.transferOrder.transferredOrder,
});

const mapDispatchToProps = {
  startTransferringOrderConnect: startTransferringOrder,
  stopTransferringOrderConnect: stopTransferringOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(TransferOrderError);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/TransferOrder/components/TransferOrderError.jsx